export default __webpack_public_path__ + "static/media/mixedMediaSq.86dc651b.jpg";